import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class VeriffService {
    static async createSession() {
        try {
            const axiosInstance = getInstanceAxios();
            const response = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/veriff/session`,
                {}
            );
            return response.data;
        } catch (error) {
            console.error("Error creating Veriff session:", error);
            throw error;
        }
    }

    static async createSessionByLink(token) {
        try {
            const axiosInstance = getInstanceAxios();
            const response = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/veriff/session-by-link`,
                { token }
            );
            return response.data;
        } catch (error) {
            console.error("Error creating Veriff session by link:", error);
            throw error;
        }
    }

    static async validateLink(token) {
        try {
            const axiosInstance = getInstanceAxios();
            const response = await axiosInstance.post(
                `${variablesGlobales.urlServiceBackend}/api/v1/veriff/validate-link`,
                { token }
            );
            return response.data;
        } catch (error) {
            console.error("Error validating Veriff link:", error);
            throw error;
        }
    }

    static async getStatus() {
        try {
            const axiosInstance = getInstanceAxios();
            const response = await axiosInstance.get(
                `${variablesGlobales.urlServiceBackend}/api/v1/veriff/status`
            );
            return response.data;
        } catch (error) {
            console.error("Error getting Veriff status:", error);
            throw error;
        }
    }
}
